export const footerTranslations = {
    en: {
        tagline: "\"Investigating with diligence, delivering with integrity.\"",
        activeSince: "Active Since 2007",
        ibnr: "IBNR–FFRM Since 2022",
        quickLinks: "Quick Links",
        links: {
            home: "Home",
            about: "About Us",
            services: "Services",
            contact: "Contact"
        },
        ourServices: "Our Services",
        services: {
            motor: "Motor Insurance Investigations",
            police: "Police Liaison",
            rti: "RTI Services",
            ibnr: "IBNR & FFRM"
        },
        contactInfo: "Contact Info",
        address: {
            line1: "Cabin No. 1, 3rd Floor, SCO 15",
            line2: "World 1 High Street Shop",
            line3: "Sector 111, Kharar-Landran Road",
            line4: "Mohali, Punjab — 140307"
        },
        rights: "Gagandeep Singh & Associates. All rights reserved.",
        coverage: "Coverage:",
        region: "Punjab & Haryana"
    },
    hi: {
        tagline: "\"परिश्रम के साथ जांच, ईमानदारी के साथ वितरण।\"",
        activeSince: "2007 से सक्रिय",
        ibnr: "2022 से IBNR-FFRM",
        quickLinks: "महत्वपूर्ण लिंक",
        links: {
            home: "मुख्य पृष्ठ",
            about: "हमारे बारे में",
            services: "सेवाएं",
            contact: "संपर्क करें"
        },
        ourServices: "हमारी सेवाएं",
        services: {
            motor: "मोटर बीमा जांच",
            police: "पुलिस संपर्क",
            rti: "आरटीआई सेवाएं",
            ibnr: "IBNR और FFRM"
        },
        contactInfo: "संपर्क जानकारी",
        address: {
            line1: "केबिन नंबर 1, तीसरी मंजिल, SCO 15",
            line2: "वर्ल्ड 1 हाई स्ट्रीट शॉप",
            line3: "सेक्टर 111, खरड़-लांडरां रोड",
            line4: "मोहाली, पंजाब — 140307"
        },
        rights: "गगनदीप सिंह एंड एसोसिएट्स। सर्वाधिकार सुरक्षित।",
        coverage: "कवरेज:",
        region: "पंजाब और हरियाणा"
    },
    pa: {
        tagline: "\"ਮਿਹਨਤ ਨਾਲ ਜਾਂਚ, ਇਮਾਨਦਾਰੀ ਨਾਲ ਸਪੁਰਦਗੀ।\"",
        activeSince: "2007 ਤੋਂ ਸਰਗਰਮ",
        ibnr: "2022 ਤੋਂ IBNR-FFRM",
        quickLinks: "ਤੇਜ਼ ਲਿੰਕ",
        links: {
            home: "ਮੁੱਖ ਪੰਨਾ",
            about: "ਸਾਡੇ ਬਾਰੇ",
            services: "ਸੇਵਾਵਾਂ",
            contact: "ਸੰਪਰਕ ਕਰੋ"
        },
        ourServices: "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ",
        services: {
            motor: "ਮੋਟਰ ਬੀਮਾ ਜਾਂਚ",
            police: "ਪੁਲਿਸ ਤਾਲਮੇਲ",
            rti: "ਆਰਟੀਆਈ ਸੇਵਾਵਾਂ",
            ibnr: "IBNR ਅਤੇ FFRM"
        },
        contactInfo: "ਸੰਪਰਕ ਜਾਣਕਾਰੀ",
        address: {
            line1: "ਕੈਬਿਨ ਨੰਬਰ 1, ਤੀਜੀ ਮੰਜ਼ਿਲ, SCO 15",
            line2: "ਵਰਲਡ 1 ਹਾਈ ਸਟ੍ਰੀਟ ਸ਼ਾਪ",
            line3: "ਸੈਕਟਰ 111, ਖਰੜ-ਲਾਂਡਰਾਂ ਰੋਡ",
            line4: "ਮੋਹਾਲੀ, ਪੰਜਾਬ — 140307"
        },
        rights: "ਗਗਨਦੀਪ ਸਿੰਘ ਐਂਡ ਐਸੋਸੀਏਟਸ। ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।",
        coverage: "ਕਵਰੇਜ:",
        region: "ਪੰਜਾਬ ਅਤੇ ਹਰਿਆਣਾ"
    }
};
